<template>
  <div class="case-create-invoice-view">
    <title-component v-if="kase.id" :size="1">
      <span v-translate="{caseNumber: kase.caseNumber}">Create invoice for case %{ caseNumber }</span>
    </title-component>
    <!-- Customer -->
    <title-component
      v-if="customer"
      :size="3"
      :lineSeparator="'under'">
      <translate>Invoice customer</translate>
    </title-component>
    <grid-details-component
      v-if="customer && invoiceCustomer"
      :display_spec="invoiceCustomerSpecs"
      :item="invoiceCustomer"
      :item_keys="invoice_customer_keys">
    </grid-details-component>
    <!-- Loader - customer -->
    <loader-component v-else :position="'relative'"></loader-component>
    <!-- Messages -->
    <message-component v-if="invoiceCustomer && !invoiceCustomer.invoiceCustomerId" :level="'warning'">
      <span v-translate>Invoice customer will be created in Mimer</span>
    </message-component>
    <message-component v-if="customer.invoiceInformationMismatch" :level="'warning'">
      <link-component :name="'InvoicingView'" :params="{ customerId: customer.id }">
        <translate> Customers invoice information has changed. Please review the new information before sending any new invoices. </translate>
      </link-component>
    </message-component>
    <!-- Invoice -->
    <title-component
      v-if="customer"
      :size="3"
      :lineSeparator="'under'">
      <translate>Invoice</translate>
    </title-component>
    <!-- Invoice create form -->
    <invoice-form-component
      v-if="kase.id"
      :kase="kase">
    </invoice-form-component>
    <!-- Popup for grouping invoices -->
    <bulk-invoice-modal-component
      v-if="invoiceCustomer"
      :caseId="caseId"
      :invoiceCustomer="invoiceCustomer">
    </bulk-invoice-modal-component>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { invoiceCustomerSpecs } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import { itemRefresher } from '@/mixins/mixins'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import LinkComponent from '@/components/layout/utility/LinkComponent'
  import BulkInvoiceModalComponent from '@/components/layout/modal/BulkInvoiceModalComponent'
  import InvoiceFormComponent from '@/components/form/InvoiceFormComponent'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'case-create-invoice-view',
    mixins: [itemRefresher],
    data () {
      return {
        invoice_customer_keys: ['companyName', 'orgNumber', 'customerId', 'fullAddress', 'vatNumber', 'gln', 'invoiceCustomerId'],
        invoiceCustomerSpecs: invoiceCustomerSpecs,
        kase: {},
        invoiceCustomer: null,
        setAction: this.setCase,
        customer: {}
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    components: {
      TitleComponent,
      GridDetailsComponent,
      MessageComponent,
      LinkComponent,
      BulkInvoiceModalComponent,
      InvoiceFormComponent,
      LoaderComponent
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'setCase',
        'setCustomer',
        'setInvoiceCustomer',
        'getInvoices'
      ]),
      setInvoiceCustomerProps () {
        this.invoiceCustomer.customerId = this.customer.customerId
        this.invoiceCustomer.fullAddress = `${this.invoiceCustomer.postalAddress}<br>${this.invoiceCustomer.postalCode}, ${this.invoiceCustomer.postalCity}`
      },
      getInvoiceCustomer () {
        if (this.customer.isConnectedToInvoiceCustomer) {
          this.setInvoiceCustomer(this.customer.invoiceCustomerId).then((invoiceCustomer) => {
            this.invoiceCustomer = invoiceCustomer
            this.setInvoiceCustomerProps()
          }).catch((err) => {
            this.handleError(err)
          })
        }
      },
      getCustomer () {
        this.setCustomer(this.kase.customer.id).then((customer) => {
          this.customer = customer
          this.getInvoiceCustomer()
        }).catch((err) => {
          this.handleError(err)
        })
      }
    },
    created () {
      let callbacks = [this.getCustomer]
      this.setOrRefreshItem('kase', this.cases, this.caseId, callbacks)
    }
  }
</script>

<style lang="sass">
  .case-create-invoice-view
    overflow: auto
</style>
